import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { map } from 'rxjs';

import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { UnderMaintenanceComponent } from 'src/app/components/under-maintenance/under-maintenance.component';
import { LaunchDarklyService } from 'src/app/services/launchdarkly.service';
import { TargetEnvironment } from 'src/environments/environment.interfaces';

import { environment } from './../environments/environment';
import { HeaderComponent } from './components/header/header.component';
import { PrivacyNoticeComponent } from './components/privacy-notice/privacy-notice.component';
import { BrowserAnalyticsService } from './services/browser-analytics.service';
import { ThemeService } from './services/theme.service';

/**
 * App component.
 */
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [HeaderComponent, PrivacyNoticeComponent, ToastModule, RouterOutlet, UnderMaintenanceComponent, AsyncPipe, CommonModule],
	providers: [MessageService, ThemeService],
})
export class AppComponent implements OnInit {
	private destroyRef = inject(DestroyRef);

	public environment = environment.environment;

	public TargetEnvironment = TargetEnvironment;

	public underMaintenance$ = this.ldService.launchDarklyFlags$.pipe(
		map(flags => {
			if (environment.environment === TargetEnvironment.Hero) {
				return flags['hero-under-maintenance'];
			} else {
				return flags['under-maintenance'];
			}
		}),
	);

	/**
	 * Constructor.
	 * @param ldService To get maintenance status.
	 * @param themeService
	 */
	constructor(
		private ldService: LaunchDarklyService,
		private themeService: ThemeService,
		private browserAnalyticsService: BrowserAnalyticsService,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.themeService.getTheme();
		this.browserAnalyticsService.start(this.router, this.destroyRef);
	}
}
